import { render, staticRenderFns } from "./notifications_dropdown.vue?vue&type=template&id=46513d7c&vue3"
import script from "./notifications_dropdown.vue?vue&type=script&lang=js&vue3"
export * from "./notifications_dropdown.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports